<template lang="pug">
.filtering__item(v-html="item")
</template>

<script>
export default {
  name: "FilteringItem",
  props: ["item"],
  data() {
    return {
      facets: [],
    };
  },
  methods: {
    getIcons() {
      let icons = [...this.$el.querySelectorAll("[data-svg]")];
      icons.forEach(async (icon) => {
        let code = await fetch(icon.getAttribute("data-svg")).then((res) =>
          res.text()
        );
        icon.insertAdjacentHTML("beforebegin", code);
        icon.parentElement.querySelector("svg").classList = icon.classList;
        icon.parentElement.removeChild(icon);
      });
    },
  },
  mounted() {
    this.getIcons();
  }
};
</script>

<style lang="scss" scoped>
.filtering__item {
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
  &::v-deep > * {
    margin: 0 !important;
  }
}
</style>